export const API_URL = 'https://inference-api-stg.dev.videahealth.io';
export const PARSE_APPLICATION_ID =
  'DwjY3wpxaUUR2Ehd4acfuRATcHuei7sPr4aHhUUjGB';
export const NETWORK_REQUEST_TIMEOUT_IN_MILLIS = 60000;
export const VIDEA_BEACON_URL = 'ws://localhost:8090/Watcher';
export const MIXPANEL_TOKEN = '325c4e7fd6f0ebeecd71b656d7987473';
export const USERPILOT_TOKEN = 'STG-NX-2caf528a';
export const BUILD_CONFIGURATION = 'FDA';
export const OKTA_DOMAIN = 'https://login.dev.videahealth.io';
export const OKTA_CLIENT_ID = '0oa1o0y7e3DcN8fCL5d7';
export const TEST_USER_OKTA = 'integration_test_user@videa.ai';
export const TEST_USER_PW = '5ng54p8e';
export const OPS_DASHBOARD_SHOW_WATCHLIST = false;
